I
<template>
  <svg
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.4588 26.9588L28.125 39.2763V6.5H24.875V39.2763L12.5412 26.9588L10.25 29.25L26.5 45.5L42.75 29.25L40.4588 26.9588Z"
      fill="var(--color, #04785E)"
    />
  </svg>
</template>
